import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: 348,
    marginTop: 24,
    overflowY: 'auto',
    borderRadius: 4,
    border: '1px solid #ECEFF1',
  },
  table: {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    width: '100%',

    '& > thead': {
      borderBottom: '1px solid #ECEFF1',

      '& > th': {
        padding: theme.spacing(2),
        fontSize: 12,
        color: '#37474F',
        position: 'sticky',
        top: 0,
        background: '#fff',

        '&.th-net-gain': {
          paddingRight: 60,
          width: 160,
        },
      },
    },

    '& > tbody': {
      '& > tr': {
        '&:not(:last-child)': {
          borderBottom: '1px solid #ECEFF1',
        },

        '& > td': {
          padding: theme.spacing(2),
          fontSize: 14,
          color: '#37474F',

          '&.td-net-gain': {
            paddingRight: 60,
          },
        },
      },
    },
  },
}));
